import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';
import { MyTeamDetailsHandler } from './my-team-details.handler';

@Component({
  selector: 'sym-my-team-details',
  templateUrl: './my-team-details.component.html',
  styleUrls: ['./my-team-details.component.scss'],
})
export class MyTeamDetailsComponent extends MyTeamDetailsHandler implements OnInit {
  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
